import type { SvgIconComponent } from '@mui/icons-material';
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import BoltRoundedIcon from '@mui/icons-material/BoltRounded';
import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded';

interface Feature {
  icon: SvgIconComponent;
  text: string;
}

export const features: Feature[] = [
  {
    icon: ChatBubbleOutlineRoundedIcon,
    text: 'No messaging or scheduling needed',
  },
  {
    icon: AccessTimeRoundedIcon,
    text: 'Review interviews on your schedule',
  },
  {
    icon: BoltRoundedIcon,
    text: 'Enjoy no hassle, faster, smarter hiring',
  },
];

export const plans = [
  { credits: 10, rate: 2.0, price: 20, save: 0 },
  { credits: 25, rate: 1.75, price: 43.75, save: 12 },
  { credits: 50, rate: 1.5, price: 75, save: 25, popular: true },
  { credits: 100, rate: 1.25, price: 125, save: 37 },
  { credits: 250, rate: 1.0, price: 250, save: 50 },
];
